import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: 16,
    borderRadius: 6,
    fontFamily: 'Manrope',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: '0.01em',
    color: colors.textHighContrast,
    border: `1px solid ${colors.inputBorder}`,
    resize: 'none',
    outline: 'none',
    // '&:placeholder': {
    //   color: colors.textLowContrast,
    // },
    // '&:focus': {
    //   borderColor: colors.primary,
    // },
    '&::placeholder': {
      opacity: 0.5,
    },
    '&:focus': {
      borderColor: colors.neutral200,
    },
  },
});
